/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the option closest to your typical week, not your best week. Sedentary means a desk job with little deliberate exercise; light is 1–3 workouts a week; moderate is 3–5; active is 6–7; very active means daily hard training or a physically demanding job. If unsure, choose the lower option.`)
};

const es_bmr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige la opción más cercana a tu semana típica, no tu mejor semana. Sedentario significa un trabajo de escritorio con poco ejercicio deliberado; ligero es 1–3 entrenamientos a la semana; moderado es 3–5; activo es 6–7; muy activo significa entrenamiento duro diario o un trabajo físicamente exigente. Si no estás seguro, elige la opción inferior.`)
};

const de_bmr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Option, die Ihrer typischen Woche am nächsten kommt, nicht Ihrer besten Woche. Sitzend bedeutet einen Schreibtischjob mit wenig absichtliches Training; Leicht ist 1–3 Trainingseinheiten pro Woche; Moderat ist 3–5; Aktiv ist 6–7; Sehr aktiv bedeutet tägliches intensives Training oder eine körperlich anstrengende Arbeit. Falls unsicher, wählen Sie die niedrigere Option.`)
};

const nl_bmr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies de optie die het meest overeenkomt met uw typische week, niet uw beste week. Sedentair betekent kantoorwerk met weinig doelbewuste oefening; licht is 1–3 trainingen per week; matig is 3–5; actief is 6–7; zeer actief betekent dagelijks intens trainen of een fysiek zwaar beroep. Twijfel niet, kies dan de lagere optie.`)
};

const fr_bmr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez l'option la plus proche de votre semaine typique, pas votre meilleure semaine. Sédentaire signifie un travail de bureau avec peu d'exercice délibéré ; léger est 1-3 séances d'entraînement par semaine ; modéré est 3-5 ; actif est 6-7 ; très actif signifie un entraînement intense quotidien ou un travail physiquement exigeant. En cas de doute, choisissez l'option inférieure.`)
};

const it_bmr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli l'opzione più vicina alla tua settimana tipica, non la tua settimana migliore. Sedentario significa un lavoro d'ufficio con poco esercizio deliberato; leggero è 1–3 allenamenti a settimana; moderato è 3–5; attivo è 6–7; molto attivo significa allenamento quotidiano intenso o un lavoro fisicamente esigente. Se non sei sicuro, scegli l'opzione inferiore.`)
};

const pt_br2_bmr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha a opção mais próxima de sua semana típica, não de sua melhor semana. Sedentário significa um trabalho de escritório com pouco exercício deliberado; leve é 1–3 treinos por semana; moderado é 3–5; ativo é 6–7; muito ativo significa treinamento duro diário ou um trabalho fisicamente exigente. Se não tem certeza, escolha a opção mais baixa.`)
};

const pt_bmr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha a opção mais próxima da sua semana típica, não da sua melhor semana. Sedentário significa um trabalho de secretária com pouco exercício deliberado; leve é 1–3 treinos por semana; moderado é 3–5; ativo é 6–7; muito ativo significa treino diário intenso ou um trabalho fisicamente exigente. Se tiver dúvidas, escolha a opção inferior.`)
};

const ja_bmr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの最良の週ではなく、あなたの典型的な週に最も近いオプションを選択してください。座りがちはデスク仕事で意図的な運動がほとんど意味します。軽度は週1～3回のワークアウト。中程度は3～5回。活発は6～7回。非常に活発は毎日の厳しいトレーニングまたは肉体労働の仕事を意味します。不確定な場合は、より低いオプションを選択してください。`)
};

const zh_bmr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择最接近您典型一周状态的选项，而不是您状态最好的那一周。久坐是指办公室工作、几乎没有刻意运动；轻度是每周锻炼 1–3 次；中度是 3–5 次；活跃是 6–7 次；非常活跃是指每天高强度训练或从事体力劳动工作。如果拿不准，请选择较低的选项。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq4_a", locale)
	if (locale === "en") return en_bmr_faq4_a(inputs)
	if (locale === "es") return es_bmr_faq4_a(inputs)
	if (locale === "de") return de_bmr_faq4_a(inputs)
	if (locale === "nl") return nl_bmr_faq4_a(inputs)
	if (locale === "fr") return fr_bmr_faq4_a(inputs)
	if (locale === "it") return it_bmr_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq4_a(inputs)
	if (locale === "pt") return pt_bmr_faq4_a(inputs)
	if (locale === "ja") return ja_bmr_faq4_a(inputs)
	return zh_bmr_faq4_a(inputs)
};